export interface CodeModel {
    id: string;
    name: { [key: string]: string };
    dataType: string;
    description: string;
    localizedName: string;
}
/**参数类型*/
export const parameterDataTypes = [
    { name: 'Common.DataTypes.Boolean', value: 'Boolean' },
    { name: 'Common.DataTypes.Integer', value: 'Integer' },
    { name: 'Common.DataTypes.Float', value: 'Float' },
    { name: 'Common.DataTypes.String', value: 'String' },
];

/**参数枚举*/
export const parameterDataTypeEnum = {
    "Boolean": "Boolean",
    "Integer": "Integer",
    "Float": "Float",
    "String": "String"
};

